import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'app/auth/services/auth.service';

@Component({
  selector: 'app-offer-icons',
  templateUrl: './offer-icons.component.html',
  styleUrls: ['./offer-icons.component.sass']
})
export class OfferIconsComponent implements OnInit {
  @Input() item: any = {};

  hasTransactionSource: boolean;

  get isAudienceTargeted(): boolean {
    return this.item?.is_targeted || !!this.item?.audience_lookalike_id;
  }

  constructor(
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.authService.getAuthenticatedUser().subscribe((response: any) => {
      if (response) {
        this.hasTransactionSource = !!response.program?.configuration?.main_source_transaction;
      }
    });
  }
}
